var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "450" },
          model: {
            value: _vm.showMonthPickerDialog,
            callback: function($$v) {
              _vm.showMonthPickerDialog = $$v
            },
            expression: "showMonthPickerDialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "pa-2" },
            [
              _c(
                "v-toolbar",
                [
                  _c(
                    "v-toolbar-side-icon",
                    [
                      _c("v-icon", { attrs: { color: "primary" } }, [
                        _vm._v("event")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-toolbar-title", { staticClass: "text--primary" }, [
                    _vm._v("\n          Select Month\n        ")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c("month-picker", {
                    attrs: {
                      "no-default": "",
                      "default-year": _vm.currentYearNumber()
                    },
                    model: {
                      value: _vm.dialogMonthYear,
                      callback: function($$v) {
                        _vm.dialogMonthYear = $$v
                      },
                      expression: "dialogMonthYear"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "accent", flat: "" },
                      on: { click: _vm.pickMonthYear }
                    },
                    [_vm._v("Done")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-toolbar",
        {
          staticClass: "pb-2",
          attrs: { extended: "", "extension-height": "75" }
        },
        [
          _vm.history
            ? _c(
                "v-layout",
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "pl-0 ml-0",
                      attrs: { flat: "", label: "", color: "accent" },
                      on: {
                        click: function($event) {
                          _vm.showMonthPickerDialog = true
                        }
                      }
                    },
                    [
                      _c("v-icon", { staticClass: "pr-2" }, [_vm._v("event")]),
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.selectedMonthYear
                              ? _vm.selectedMonthYear.month +
                                  ", " +
                                  _vm.selectedMonthYear.year
                              : "Select Month"
                          ) +
                          "\n      "
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _c("v-toolbar-title", [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _vm._t("toolbarItems"),
          _vm._v(" "),
          _vm.customerLoadCount ||
          _vm.carrierLoadCount ||
          _vm.groupedLoadCount ||
          _vm.groupLoadsByCustomer ||
          _vm.groupLoadsByCarrier ||
          _vm.customGroupedItems
            ? _c(
                "v-btn-toggle",
                { attrs: { mandatory: "" } },
                [
                  _c("v-btn", [_c("v-icon", [_vm._v("dehaze")])], 1),
                  _vm._v(" "),
                  _vm.customerLoadCount || _vm.groupLoadsByCustomer
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            color: _vm.groupLoadsByCustomer ? "green" : null
                          },
                          model: {
                            value: _vm.groupLoadsByCustomer,
                            callback: function($$v) {
                              _vm.groupLoadsByCustomer = $$v
                            },
                            expression: "groupLoadsByCustomer"
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                color: _vm.groupLoadsByCustomer ? "white" : null
                              }
                            },
                            [_vm._v("\n          face\n        ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.carrierLoadCount || _vm.groupLoadsByCarrier
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            color: _vm.groupLoadsByCarrier ? "accent" : null
                          },
                          model: {
                            value: _vm.groupLoadsByCarrier,
                            callback: function($$v) {
                              _vm.groupLoadsByCarrier = $$v
                            },
                            expression: "groupLoadsByCarrier"
                          }
                        },
                        [
                          _vm.dispatched
                            ? _c(
                                "v-icon",
                                {
                                  attrs: {
                                    color: _vm.groupLoadsByCarrier
                                      ? "white"
                                      : null
                                  }
                                },
                                [_vm._v("\n          share\n        ")]
                              )
                            : _c(
                                "v-icon",
                                {
                                  attrs: {
                                    color: _vm.groupLoadsByCarrier
                                      ? "white"
                                      : null
                                  }
                                },
                                [_vm._v("\n          local_shipping\n        ")]
                              )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.groupedLoadCount || _vm.customGroupedItems
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            color: _vm.customGroupedItems ? "primary" : null
                          },
                          model: {
                            value: _vm.customGroupedItems,
                            callback: function($$v) {
                              _vm.customGroupedItems = $$v
                            },
                            expression: "customGroupedItems"
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                color: _vm.customGroupedItems ? "white" : null
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.customGroupIcon) +
                                  "\n        "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { slot: "extension", column: "" }, slot: "extension" },
            [
              _vm.accurateSince
                ? _c(
                    "div",
                    { staticClass: "pa-0 ma-0 text-right align-center" },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "" } },
                        [
                          _c(
                            "v-chip",
                            {
                              staticClass: "font-weight-light",
                              attrs: { label: "", light: "" }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.accurateSince) +
                                  "\n            "
                              ),
                              _vm.history
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        fab: "",
                                        small: "",
                                        flat: "",
                                        color: "accent",
                                        disabled: !_vm.selectedMonthYear
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.$emit(
                                            "loadMonth",
                                            _vm.selectedMonthYear
                                          )
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("refresh")])],
                                    1
                                  )
                                : _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        fab: "",
                                        small: "",
                                        flat: "",
                                        color: "accent"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.$emit("refresh")
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("refresh")])],
                                    1
                                  )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-layout",
                {
                  attrs: {
                    slot: "extension",
                    "justify-end": "",
                    "align-end": ""
                  },
                  slot: "extension"
                },
                [
                  _c("v-text-field", {
                    staticClass: "single-line hide-details pb-0 mb-0",
                    attrs: {
                      disabled: _vm.history
                        ? !_vm.selectedMonthYear
                        : !_vm.loads.length && !_vm.searchTerm,
                      "append-icon": "search",
                      label: _vm.searchPrompt
                    },
                    on: {
                      input: function($event) {
                        return _vm.$emit("update:searchTerm", _vm.searchTerm)
                      }
                    },
                    model: {
                      value: _vm.searchTerm,
                      callback: function($$v) {
                        _vm.searchTerm = $$v
                      },
                      expression: "searchTerm"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-card",
        {
          staticClass: "pt-4",
          class: { "side-list-desktop": !_vm.isMobile },
          attrs: { "pl-4": "" }
        },
        [
          _vm.loading
            ? _c(
                "v-layout",
                [
                  _vm._t("loading", function() {
                    return [
                      _c("v-progress-circular", {
                        staticClass: "mx-auto",
                        attrs: { indeterminate: "", color: "primary" }
                      })
                    ]
                  })
                ],
                2
              )
            : _c(
                "v-list",
                { attrs: { "two-line": "" } },
                [
                  _vm._t("subheader", function() {
                    return [
                      _vm.subheader
                        ? _c(
                            "v-subheader",
                            [
                              _vm.subheaderIcon
                                ? _c(
                                    "v-icon",
                                    {
                                      staticClass: "pr-2",
                                      attrs: { color: "primary" }
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(_vm.subheaderIcon) +
                                          "\n          "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(
                                "\n          " + _vm._s(_vm.subheader) + " "
                              ),
                              _vm.subheaderCount != null
                                ? _c("span", [
                                    _vm._v(
                                      "(" + _vm._s(_vm.subheaderCount) + ")"
                                    )
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.loads, function(load, idx) {
                    return !_vm.groupLoadsByCustomer &&
                      !_vm.groupLoadsByCarrier &&
                      !_vm.customGroupedItems
                      ? [
                          _vm._t(
                            "loadTile",
                            function() {
                              return [_vm._v("\n          fallback\n        ")]
                            },
                            { load: load, idx: idx }
                          )
                        ]
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.customerLoads, function(loads, sponsor, idx) {
                    return _vm.groupLoadsByCustomer && _vm.customerLoadCount
                      ? [
                          _vm._t(
                            "customerLoadsTile",
                            function() {
                              return [
                                _vm._v(
                                  "\n          customer loads fallback\n        "
                                )
                              ]
                            },
                            { loads: loads, sponsor: sponsor, idx: idx }
                          )
                        ]
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.carrierLoads, function(loads, carrier, idx) {
                    return _vm.groupLoadsByCarrier && _vm.carrierLoads != null
                      ? [
                          _vm._t(
                            "carrierLoadsTile",
                            function() {
                              return [
                                _vm._v(
                                  "\n          carrier loads fallback\n        "
                                )
                              ]
                            },
                            { loads: loads, carrier: carrier, idx: idx }
                          )
                        ]
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.groupedItems, function(items, item, idx) {
                    return _vm.customGroupedItems && _vm.groupedItems != null
                      ? [
                          _vm._t(
                            "groupedItemsTile",
                            function() {
                              return [
                                _vm._v(
                                  "\n          Custom items slot\n        "
                                )
                              ]
                            },
                            { items: items, item: item, idx: idx }
                          )
                        ]
                      : _vm._e()
                  })
                ],
                2
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3adf52ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3adf52ee","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/simple/LoadNavList.vue
// module id = null
// module chunks = 